<template>
  <label class="slider-switch relative inline-block">
    <input
      class="hidden"
      type="checkbox"
      :name="fieldName"
      v-model="checked"
      value="1"
      @change="checkboxChanged">
    <span
      class="slider rounded-full absolute cursor-pointer inset-0"
      :class="checked ? classOn : classOff">
    </span>
  </label>
</template>
<script>
export default{
  name: 'slider-switch',
  props: {
    fieldName: {
      type: String,
      default: 'field'
    },
    initiallyChecked: {
      type: Boolean,
      default: false
    },
    classOff: {
      type: String,
      default: 'bg-gray-300'
    },
    classOn: {
      type: String,
      default: 'bg-green-500'
    }
  },
  data: function() {
    return {
      checked: false
    }
  },
  mounted() {
    this.checked = this.initiallyChecked;
  },
  methods: {
    checkboxChanged: function() {
      this.$emit('changed', this.checked);
    }
  }
}
</script>
